import 'styled-components'
import type { SPACE } from './constants'
import type { theme } from './theme'
import type { CSSObject, DefaultTheme } from 'styled-components'

declare module 'styled-components' {
  export interface DefaultTheme {
    colors: typeof theme.colors
    radius: typeof theme.radius
    fonts: typeof theme.fonts
    spacing: typeof theme.spacing
    fontSize: typeof theme.fontSize
    animationSpeed: typeof theme.animationSpeed
    fontWeight: typeof theme.fontWeight
    border: typeof theme.border
    helpers: typeof theme.helpers
  }
}

export type InnerType = CSSObject

export type ThemeColor = keyof DefaultTheme['colors']
export type ThemeBorder = keyof DefaultTheme['border']
export type ThemeRadius = keyof DefaultTheme['radius']
export type ThemeFontFamily = keyof DefaultTheme['fonts']
export type ThemeFontWeight = keyof DefaultTheme['fontWeight']
export type ThemeFontSize = Parameters<
  DefaultTheme['helpers']['getFontSizeStyles']
>[0]

export type Breakpoint =
  | 'base'
  | 'm'
  | 'mt'
  | 't'
  | 'td'
  | 'd'
  | 'ds'
  | 'dm'
  | 'dl'
  | 'dx'

export type ResponsiveObject<Value> = Partial<Record<Breakpoint, Value>>
export type ResponsiveValue<T> = T | ResponsiveObject<T>
export type Responsive<K, V> = Record<keyof K, ResponsiveValue<V>>

export type Space = keyof typeof SPACE
export type SpaceExtended = Space | 'auto' | 'unset' | 'inherit'

export type Margin = {
  /**
   * margin: 0px;
   */
  $m: SpaceExtended
  /**
   * margin-left: 0px;
   * margin-right: 0px;
   */
  $mx: SpaceExtended
  /**
   * margin-top: 0px;
   * margin-bottom: 0px;
   */
  $my: SpaceExtended
  /**
   * margin-inline-start: 0px;
   */
  $ms: SpaceExtended
  /**
   * margin-inline-end: 0px;
   */
  $me: SpaceExtended
  /**
   * margin-top: 0px;
   */
  $mt: SpaceExtended
  /**
   * margin-right: 0px;
   */
  $mr: SpaceExtended
  /**
   * margin-bottom: 0px;
   */
  $mb: SpaceExtended
  /**
   * margin-left: 0px;
   */
  $ml: SpaceExtended
}
export type MarginResponsive = Responsive<Margin, SpaceExtended>

export type Padding = {
  /**
   * padding: 0px;
   */
  $p: SpaceExtended
  /**
   * padding-left: 0px;
   * padding-right: 0px;
   */
  $px: SpaceExtended
  /**
   * padding-top: 0px;
   * padding-bottom: 0px;
   */
  $py: SpaceExtended
  /**
   * padding-inline-start: 0px;
   */
  $ps: SpaceExtended
  /**
   * padding-inline-end: 0px;
   */
  $pe: SpaceExtended
  /**
   * padding-top: 0px;
   */
  $pt: SpaceExtended
  /**
   * padding-right: 0px;
   */
  $pr: SpaceExtended
  /**
   * padding-bottom: 0px;
   */
  $pb: SpaceExtended
  /**
   * padding-left: 0px;
   */
  $pl: SpaceExtended
}
export type PaddingResponsive = Responsive<Padding, SpaceExtended>
